import * as scoreUtil from "core/src/core/score/score-util.js";
import type { ScoreMap } from "./types";

// A tie-break is on: the match SHOULD be over on its own terms (the target
// score is reached, or the rounds are played out) but the top is shared, so
// extra rounds are played until someone is ahead (core match.js isMatchOver).
// Score mode: the top score is at or past the target. Rounds mode: every
// scheduled round is played. Either way: two or more players share the top.
export function isTieBreak(score: ScoreMap | null | undefined, maxScore?: number | null, maxRounds?: number | null, roundsPlayed?: number): boolean {
  if (!score) return false;
  const sorted = scoreUtil.createSortedList(score);
  if (sorted.length < 2 || sorted[0].score !== sorted[1].score) return false;
  if (maxRounds) return (roundsPlayed || 0) >= maxRounds;
  return !!maxScore && sorted[0].score >= maxScore;
}
